export const CSS_LEXILE_BASE = 'dpg--lexile--';
export const CSS_LEXILE_CONTAINER = `${CSS_LEXILE_BASE}container`;
export const CSS_DPG_LEXILE_SHOW_PREFIX = `${CSS_LEXILE_BASE}show_`;
export const CSS_LEXILE_CONTEXT_PREFIX = 'mhe-context-lexile-';
